import { buildEmailPreferencesOrEmpty } from './EmailPreferences';
import { buildProductUsageOrEmpty } from './ProductUsage';
export const buildContactFieldsOrEmpty = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (!data) {
        return {
            industry: null,
            persona: null,
            jobTitleNormalized: null,
            currentCADSystem: null,
            productSkuAtSignup: null,
            csmName: null,
            csmEmail: null,
            productUsage: buildProductUsageOrEmpty({}),
            emailPreferences: buildEmailPreferencesOrEmpty({}),
            contactOwnerMeetingLink: null,
            csOwnerMeetingLink: null,
            salesPersonMeetingLink: null,
            salesOpps: 0,
        };
    }
    return {
        industry: (_a = data.industry) !== null && _a !== void 0 ? _a : null,
        persona: (_b = data.persona) !== null && _b !== void 0 ? _b : null,
        jobTitleNormalized: (_c = data.jobTitleNormalized) !== null && _c !== void 0 ? _c : null,
        currentCADSystem: (_d = data.currentCADSystem) !== null && _d !== void 0 ? _d : null,
        productSkuAtSignup: (_e = data.productSkuAtSignup) !== null && _e !== void 0 ? _e : null,
        csmName: (_f = data.csmName) !== null && _f !== void 0 ? _f : null,
        csmEmail: (_g = data.csmEmail) !== null && _g !== void 0 ? _g : null,
        productUsage: buildProductUsageOrEmpty(data.productUsage),
        emailPreferences: buildEmailPreferencesOrEmpty(data.emailPreferences),
        contactOwnerMeetingLink: (_h = data.contactOwnerMeetingLink) !== null && _h !== void 0 ? _h : null,
        csOwnerMeetingLink: (_j = data.csOwnerMeetingLink) !== null && _j !== void 0 ? _j : null,
        salesPersonMeetingLink: (_k = data.salesPersonMeetingLink) !== null && _k !== void 0 ? _k : null,
        salesOpps: (_l = data.salesOpps) !== null && _l !== void 0 ? _l : 0,
    };
};
export const buildContactFieldsFromEloquaData = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        industry: null,
        persona: null,
        jobTitleNormalized: (_a = data.jobTitleNormalized) !== null && _a !== void 0 ? _a : null,
        currentCADSystem: (_b = data.currentCADSystem) !== null && _b !== void 0 ? _b : null,
        productSkuAtSignup: (_c = data.productSkuAtSignup) !== null && _c !== void 0 ? _c : null,
        csmName: (_d = data.csmName) !== null && _d !== void 0 ? _d : null,
        csmEmail: (_e = data.csmEmail) !== null && _e !== void 0 ? _e : null,
        productUsage: buildProductUsageOrEmpty(data),
        emailPreferences: buildEmailPreferencesOrEmpty(data),
        contactOwnerMeetingLink: (_f = data.contactOwnerMeetingLink) !== null && _f !== void 0 ? _f : null,
        csOwnerMeetingLink: (_g = data.csOwnerMeetingLink) !== null && _g !== void 0 ? _g : null,
        salesPersonMeetingLink: (_h = data.salesPersonMeetingLink) !== null && _h !== void 0 ? _h : null,
        salesOpps: (_j = data.salesOpps) !== null && _j !== void 0 ? _j : 0,
    };
};
